import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Table, Tag, Button, Dropdown, Avatar, Tooltip, Modal, Input, message, Spin, Row, Col, Tabs, Empty, Space } from "antd";
import {
  ArrowLeftOutlined,
  FilePdfOutlined,
  VideoCameraOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  MoreOutlined,
  DollarOutlined,
  CalendarOutlined,
  CommentOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  EyeOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  UserAddOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { JobDetailsWrapper } from "./JobDetails.style";
import axios from "axios";
import { API_CONST } from "../../../const";

const mockJobDetails = {
  "2930493": {
    id: "2930493",
    title: "SAP Hana Developer",
    type: "Full Time Contract",
    salary: "₹1,50,000 / Month (6 Months)",
    location: "Remote",
    openPositions: 2,
    salaryPerMonth: "1,50,000",
    projectDuration: "6 Months",
    communication: "Excellent",
    primarySkills: [
      { skill: "SAP HANA", level: "Expert" },
      { skill: "SQL", level: "Advanced" },
      { skill: "Data Modeling", level: "Expert" },
    ],
    description: "We are looking for an experienced SAP Hana Developer with 5 to 6 years of experience.",
    submittedProfiles: [
      {
        id: 1,
        name: "Akshay Joshi",
        role: "SAP HANA Developer",
        skills: [
          { skill: "SAP HANA", level: "Expert" },
          { skill: "SQL", level: "Advanced" },
        ],
        monthlyRate: "₹ 75,000",
        experience: "5.2 Year",
        noticePeriod: "30 Days",
        resumeUrl: "#",
        status: "submitted",
      },
      {
        id: 2,
        name: "Vineet Malhotra",
        role: "SAP HANA Developer",
        skills: [
          { skill: "SAP HANA", level: "Expert" },
          { skill: "Data Modeling", level: "Expert" },
        ],
        monthlyRate: "₹ 80,000",
        experience: "5.8 Year",
        noticePeriod: "45 Days",
        resumeUrl: "#",
        status: "submitted",
      },
      {
        id: 3,
        name: "Raj Kumar",
        role: "SAP HANA Developer",
        skills: [
          { skill: "SAP HANA", level: "Advanced" },
          { skill: "SQL", level: "Expert" },
        ],
        monthlyRate: "₹ 70,000",
        experience: "5.0 Year",
        noticePeriod: "30 Days",
        resumeUrl: "#",
        status: "interviewing",
      },
    ],
  },
  "2930494": {
    id: "2930494",
    title: "React Frontend Developer",
    type: "Full Time Contract",
    salary: "₹90,000 / Month (12 Months)",
    location: "Bangalore",
    openPositions: 1,
    salaryPerMonth: "90,000",
    projectDuration: "12 Months",
    communication: "Good",
    primarySkills: [
      { skill: "React", level: "Expert" },
      { skill: "TypeScript", level: "Advanced" },
      { skill: "Redux", level: "Expert" },
    ],
    description: "Looking for a skilled React developer with 3 to 5 years of experience.",
    submittedProfiles: [
      {
        id: 4,
        name: "Priya Sharma",
        role: "React Developer",
        skills: [
          { skill: "React", level: "Expert" },
          { skill: "TypeScript", level: "Advanced" },
        ],
        monthlyRate: "₹ 65,000",
        experience: "3.5 Year",
        noticePeriod: "15 Days",
        resumeUrl: "#",
        status: "submitted",
      },
      {
        id: 5,
        name: "Amit Singh",
        role: "React Developer",
        skills: [
          { skill: "React", level: "Expert" },
          { skill: "Redux", level: "Expert" },
        ],
        monthlyRate: "₹ 70,000",
        experience: "4.0 Year",
        noticePeriod: "30 Days",
        resumeUrl: "#",
        status: "interviewing",
      },
    ],
  },
  "2930495": {
    id: "2930495",
    title: "DevOps Engineer",
    type: "Contract",
    salary: "₹1,20,000 / Month (6 Months)",
    location: "Remote",
    openPositions: 1,
    salaryPerMonth: "1,20,000",
    projectDuration: "6 Months",
    communication: "Excellent",
    primarySkills: [
      { skill: "Docker", level: "Expert" },
      { skill: "Kubernetes", level: "Advanced" },
      { skill: "AWS", level: "Expert" },
    ],
    description: "Looking for an experienced DevOps Engineer with 4 to 7 years of experience.",
    submittedProfiles: [
      {
        id: 6,
        name: "Karthik Reddy",
        role: "DevOps Engineer",
        skills: [
          { skill: "Docker", level: "Expert" },
          { skill: "Kubernetes", level: "Advanced" },
        ],
        monthlyRate: "₹ 95,000",
        experience: "6.0 Year",
        noticePeriod: "60 Days",
        resumeUrl: "#",
        status: "submitted",
      },
    ],
  },
  "2930496": {
    id: "2930496",
    title: "Python Backend Developer",
    type: "Full Time",
    salary: "₹75,000 / Month (12 Months)",
    location: "Hyderabad",
    openPositions: 2,
    salaryPerMonth: "75,000",
    projectDuration: "12 Months",
    communication: "Good",
    primarySkills: [
      { skill: "Python", level: "Expert" },
      { skill: "Django", level: "Advanced" },
      { skill: "PostgreSQL", level: "Advanced" },
    ],
    description: "Looking for a Python Backend Developer with 2 to 4 years of experience.",
    submittedProfiles: [
      {
        id: 7,
        name: "Neha Gupta",
        role: "Python Developer",
        skills: [
          { skill: "Python", level: "Expert" },
          { skill: "Django", level: "Advanced" },
        ],
        monthlyRate: "₹ 60,000",
        experience: "3.0 Year",
        noticePeriod: "30 Days",
        resumeUrl: "#",
        status: "submitted",
      },
      {
        id: 8,
        name: "Rohit Mehta",
        role: "Python Developer",
        skills: [
          { skill: "Python", level: "Expert" },
          { skill: "PostgreSQL", level: "Advanced" },
        ],
        monthlyRate: "₹ 58,000",
        experience: "2.5 Year",
        noticePeriod: "15 Days",
        resumeUrl: "#",
        status: "interviewing",
      },
    ],
  },
};

const JobDetails = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profiles, setProfiles] = useState([]);
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [activeProfileTab, setActiveProfileTab] = useState("submitted");
  const [matchedTalents, setMatchedTalents] = useState([]);
  const [matchedLoading, setMatchedLoading] = useState(false);
  const [requestStatusMap, setRequestStatusMap] = useState({});
  const [requestingTalentId, setRequestingTalentId] = useState(null);

  const formatCurrency = (amount) => {
    if (!amount) return '-';
    return `₹ ${Number(amount).toLocaleString('en-IN')}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  useEffect(() => {
    console.log('Customer JobDetails useEffect triggered, jobId:', jobId);
    
    const fetchSubmittedProfiles = async () => {
      try {
        console.log('Fetching submitted profiles for jobId:', jobId);
        const token = localStorage.getItem("authToken");
        const response = await axios.post(
          API_CONST.GET_JOB_APPLICATIONS,
          { jobId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        console.log('Customer API response:', response.data);
        if (response.data.applications) {
          const mappedProfiles = response.data.applications.map((app) => ({
            id: app.applicationId,
            talentId: app.talentId,
            name: app.talent?.name || 'Unknown',
            role: app.talent?.role || 'N/A',
            skills: app.talent?.primarySkills || app.talent?.skills || [],
            primarySkills: app.talent?.primarySkills || [],
            monthlyRate: formatCurrency(app.talent?.clientRate),
            experience: app.talent?.experience || 'N/A',
            noticePeriod: app.talent?.noticePeriod || 'N/A',
            resumeUrl: app.talent?.resumeUrl,
            status: app.status,
            submittedAt: app.submittedAt,
          }));
          console.log('Mapped profiles:', mappedProfiles);
          setProfiles(mappedProfiles);
        }
      } catch (error) {
        console.error("Error fetching submitted profiles:", error);
      }
    };

    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${API_CONST.GET_JOB_REQUIREMENT}/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        console.log('Job details response:', response.data);
        if (response.data.job) {
          setJobData(response.data.job);
        }
      } catch (error) {
        console.error("Error fetching job details:", error);
        message.error("Failed to load job details");
      } finally {
        setLoading(false);
      }
    };

    if (jobId) {
      fetchJobDetails();
      fetchSubmittedProfiles();
    }
  }, [jobId]);

  const fetchMatchedProfiles = async () => {
    setMatchedLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const [matchedRes, statusRes] = await Promise.all([
        axios.get(`${API_CONST.GET_MATCHED_TALENTS}/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_CONST.GET_INTERVIEW_REQUEST_STATUS}/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setMatchedTalents(matchedRes.data.matched || []);
      setRequestStatusMap(statusRes.data.statusMap || {});
    } catch (error) {
      console.error("Error fetching matched profiles:", error);
      message.error("Failed to load matched profiles");
    } finally {
      setMatchedLoading(false);
    }
  };

  const handleRequestInterview = (talent) => {
    Modal.confirm({
      title: "Send Interview Request",
      content: `Send an interview request for ${talent.name} to the partner? The partner will receive this request and can accept or reject it.`,
      okText: "Send Request",
      cancelText: "Cancel",
      onOk: async () => {
        setRequestingTalentId(talent.id);
        try {
          const token = localStorage.getItem("authToken");
          const response = await axios.post(
            API_CONST.CREATE_INTERVIEW_REQUEST,
            { jobId, talentId: talent.id },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const newRequestId = response.data?.request?.id || null;
          setRequestStatusMap((prev) => ({
            ...prev,
            [talent.id]: { requestId: newRequestId, status: "pending", createdAt: new Date() },
          }));
          message.success(`Interview request sent for ${talent.name}`);
        } catch (error) {
          if (error.response?.status === 409) {
            message.warning("An interview request already exists for this talent");
          } else {
            message.error("Failed to send interview request");
          }
        } finally {
          setRequestingTalentId(null);
        }
      },
    });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'open': return 'green';
      case 'closed': return 'red';
      case 'filled': return 'blue';
      case 'draft': return 'orange';
      default: return 'default';
    }
  };

  if (loading) {
    return (
      <JobDetailsWrapper>
        <div style={{ padding: "40px", textAlign: "center" }}>
          <Spin size="large" />
          <p style={{ marginTop: 16 }}>Loading job details...</p>
        </div>
      </JobDetailsWrapper>
    );
  }

  if (!jobData) {
    return (
      <JobDetailsWrapper>
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Job not found</h2>
          <Button type="primary" onClick={() => navigate("/customer/my-jobs")}>
            Back to My Jobs
          </Button>
        </div>
      </JobDetailsWrapper>
    );
  }

  const updateApplicationStatus = async (applicationId, status) => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.put(
        `${API_CONST.UPDATE_JOB_APPLICATION}/${applicationId}`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return true;
    } catch (error) {
      console.error("Error updating application status:", error);
      message.error("Failed to update status");
      return false;
    }
  };

  const handleScheduleInterview = (profile) => {
    Modal.confirm({
      title: "Schedule Interview",
      icon: <VideoCameraOutlined style={{ color: "#1890ff" }} />,
      content: (
        <div>
          <p>Are you sure you want to schedule an interview for this candidate?</p>
          <div style={{ 
            marginTop: 12, 
            padding: 12, 
            background: "#f8f9fd", 
            borderRadius: 6 
          }}>
            <p style={{ margin: 0, fontWeight: 500 }}>{profile.name}</p>
            <p style={{ margin: "4px 0 0", color: "#666", fontSize: 13 }}>{profile.role}</p>
          </div>
        </div>
      ),
      okText: "Schedule Interview",
      okButtonProps: { 
        style: { background: "#00d9a9", borderColor: "#00d9a9" }
      },
      cancelText: "Cancel",
      onOk: async () => {
        const success = await updateApplicationStatus(profile.id, "interview_scheduled");
        if (success) {
          setProfiles(
            profiles.map((p) =>
              p.id === profile.id 
                ? { ...p, previousStatus: p.status, status: "interview_scheduled" } 
                : p
            )
          );
          message.success(`Interview scheduled for ${profile.name}`);
        }
      },
    });
  };

  const handleCancelInterview = (profile) => {
    setSelectedProfile(profile);
    setCancelReason("");
    setCancelModalVisible(true);
  };

  const handleSubmitCancelInterview = async () => {
    if (!cancelReason.trim()) {
      message.warning("Please provide a reason for cancelling the interview");
      return;
    }

    const success = await updateApplicationStatus(selectedProfile.id, "submitted");
    if (success) {
      setProfiles(
        profiles.map((p) =>
          p.id === selectedProfile.id 
            ? { ...p, status: "submitted", previousStatus: undefined } 
            : p
        )
      );
      message.success(`Interview cancelled for ${selectedProfile.name}`);
    }
    setCancelModalVisible(false);
    setSelectedProfile(null);
    setCancelReason("");
  };

  const handleAction = (profileId, action) => {
    if (action === "hired") {
      Modal.confirm({
        title: "Hire Candidate",
        icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        content: "Are you sure you want to hire this candidate?",
        okText: "Hire",
        okButtonProps: { style: { background: "#52c41a", borderColor: "#52c41a" } },
        onOk: async () => {
          const success = await updateApplicationStatus(profileId, "hired");
          if (success) {
            setProfiles(
              profiles.map((p) =>
                p.id === profileId ? { ...p, status: action } : p
              )
            );
            message.success("Candidate hired successfully");
          }
        },
      });
    } else if (action === "rejected") {
      Modal.confirm({
        title: "Reject Candidate",
        icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
        content: "Are you sure you want to reject this candidate?",
        okText: "Reject",
        okButtonProps: { danger: true },
        onOk: async () => {
          const success = await updateApplicationStatus(profileId, "rejected");
          if (success) {
            setProfiles(
              profiles.map((p) =>
                p.id === profileId ? { ...p, status: action } : p
              )
            );
            message.success("Candidate rejected");
          }
        },
      });
    } else {
      const updateStatus = async () => {
        const success = await updateApplicationStatus(profileId, action);
        if (success) {
          setProfiles(
            profiles.map((profile) =>
              profile.id === profileId ? { ...profile, status: action } : profile
            )
          );
        }
      };
      updateStatus();
    }
  };

  const getActionMenuItems = (record) => {
    const items = [];

    if (record.status === "interview_scheduled") {
      items.push({
        key: "cancel",
        label: "Cancel Interview",
        icon: <StopOutlined />,
        danger: true,
        onClick: () => handleCancelInterview(record),
      });
    }

    items.push(
      {
        key: "hire",
        label: "Hire",
        icon: <CheckCircleOutlined />,
        onClick: () => handleAction(record.id, "hired"),
      },
      {
        key: "reject",
        label: "Reject",
        icon: <CloseCircleOutlined />,
        danger: true,
        onClick: () => handleAction(record.id, "rejected"),
      }
    );

    return items;
  };

  const columns = [
    {
      title: "Resume",
      dataIndex: "resumeUrl",
      key: "resume",
      width: 80,
      render: (url) => (
        <Tooltip title="View Resume">
          <FilePdfOutlined
            style={{ fontSize: 24, color: "#ff4d4f", cursor: "pointer" }}
            onClick={() => window.open(url, "_blank")}
          />
        </Tooltip>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (name, record) => (
        <a
          href="#"
          style={{ color: "#1890ff", fontWeight: 500 }}
          onClick={(e) => {
            e.preventDefault();
            navigate(`/customer/talent-details/${record.id}`);
          }}
        >
          {name}
        </a>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: 150,
    },
    {
      title: "Top Skills",
      dataIndex: "skills",
      key: "skills",
      width: 300,
      render: (skills) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {(skills || []).map((skill, index) => (
            <Tag key={index} color="cyan" style={{ margin: "2px 0" }}>
              {typeof skill === 'object' ? `${skill.skill} - ${skill.level}` : skill}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "Monthly Rate",
      dataIndex: "monthlyRate",
      key: "monthlyRate",
      width: 120,
      render: (rate) => <span style={{ fontWeight: 500 }}>{rate}</span>,
    },
    {
      title: "Experience",
      dataIndex: "experience",
      key: "experience",
      width: 100,
    },
    {
      title: "Notice Period",
      dataIndex: "noticePeriod",
      key: "noticePeriod",
      width: 120,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => {
        const config = {
          submitted: { color: "blue", text: "Submitted" },
          interview_scheduled: { color: "orange", text: "Interview Scheduled" },
          interviewing: { color: "orange", text: "Interviewing" },
          hired: { color: "green", text: "Hired" },
          rejected: { color: "red", text: "Rejected" },
        };
        const { color, text } = config[status] || { color: "default", text: status };
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <Tooltip title={record.status === "interview_scheduled" ? "Interview Scheduled" : "Schedule Interview"}>
            <Button
              type="primary"
              icon={<VideoCameraOutlined />}
              size="small"
              disabled={record.status === "interview_scheduled" || record.status === "hired" || record.status === "rejected"}
              onClick={() => handleScheduleInterview(record)}
              style={
                record.status === "interview_scheduled"
                  ? { background: "#d9d9d9", borderColor: "#d9d9d9" }
                  : {}
              }
            />
          </Tooltip>
          <Tooltip title="Download Resume">
            <Button
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => window.open(record.resumeUrl, "_blank")}
            />
          </Tooltip>
          <Dropdown 
            menu={{ items: getActionMenuItems(record) }} 
            trigger={["click"]}
          >
            <Button icon={<MoreOutlined />} size="small" />
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <JobDetailsWrapper>
      <div className="header">
        <div className="header-left">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/customer/my-jobs")}
            className="back-button"
          >
            Back to Jobs
          </Button>
          <h2>Ongoing Jobs</h2>
        </div>
        <Button
          type="primary"
          icon={<EyeOutlined />}
          onClick={() => navigate(`/customer/view-job/${jobId}`)}
          className="view-details-btn"
        >
          View Job Details
        </Button>
      </div>

      <Card className="job-summary-card">
        <div className="job-header">
          <div>
            <div className="job-id">Job ID: {jobData.id}</div>
            <h2 className="job-title">{jobData.role || jobData.title}</h2>
            <div className="job-meta">
              <Tag color={getStatusColor(jobData.status)}>{jobData.status?.toUpperCase()}</Tag>
              <Tag color="blue">{jobData.engagementType}</Tag>
              <Tag color="cyan" icon={<EnvironmentOutlined />}>{jobData.reportingLocation}</Tag>
              <Tag color="green" icon={<TeamOutlined />}>Requirements: {jobData.numberOfRequirements}</Tag>
            </div>
          </div>
        </div>

        <div className="metrics-row">
          <div className="metric-box">
            <div className="metric-icon" style={{ background: "#e6f7ff" }}>
              <DollarOutlined style={{ fontSize: 24, color: "#1890ff" }} />
            </div>
            <div className="metric-info">
              <h3>{formatCurrency(jobData.budget)}</h3>
              <p>{jobData.budgetPeriod || 'Per Month'}</p>
            </div>
          </div>
          <div className="metric-box">
            <div className="metric-icon" style={{ background: "#fff7e6" }}>
              <CalendarOutlined style={{ fontSize: 24, color: "#fa8c16" }} />
            </div>
            <div className="metric-info">
              <h3>{jobData.monthsOfEngagement || '-'}</h3>
              <p>Engagement Duration</p>
            </div>
          </div>
          <div className="metric-box">
            <div className="metric-icon" style={{ background: "#f6ffed" }}>
              <ClockCircleOutlined style={{ fontSize: 24, color: "#52c41a" }} />
            </div>
            <div className="metric-info">
              <h3>{jobData.experienceRange || '-'}</h3>
              <p>Experience Required</p>
            </div>
          </div>
          <div className="metric-box">
            <div className="metric-icon" style={{ background: "#fff1f0" }}>
              <CommentOutlined style={{ fontSize: 24, color: "#ff4d4f" }} />
            </div>
            <div className="metric-info">
              <h3>{jobData.communication || '-'}</h3>
              <p>Communication Level</p>
            </div>
          </div>
        </div>

        <Row gutter={[24, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontWeight: 600, color: "#262626" }}>Primary Skills:</span>
              <div style={{ marginTop: 4 }}>
                {(jobData.primarySkills || []).map((skill, index) => (
                  <Tag key={index} color="blue" style={{ marginBottom: 4 }}>
                    {typeof skill === 'object' ? `${skill.skill} - ${skill.level}` : skill}
                  </Tag>
                ))}
                {(!jobData.primarySkills || jobData.primarySkills.length === 0) && (
                  <span style={{ color: "#8c8c8c" }}>None specified</span>
                )}
              </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontWeight: 600, color: "#262626" }}>Secondary Skills:</span>
              <div style={{ marginTop: 4 }}>
                {(jobData.secondarySkills || []).map((skill, index) => (
                  <Tag key={index} color="green" style={{ marginBottom: 4 }}>
                    {skill}
                  </Tag>
                ))}
                {(!jobData.secondarySkills || jobData.secondarySkills.length === 0) && (
                  <span style={{ color: "#8c8c8c" }}>None specified</span>
                )}
              </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontWeight: 600, color: "#262626" }}>Start Date:</span>
              <div style={{ marginTop: 4, fontWeight: 500 }}>{formatDate(jobData.tentativeStartDate)}</div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontWeight: 600, color: "#262626" }}>Created On:</span>
              <div style={{ marginTop: 4, fontWeight: 500 }}>{formatDate(jobData.createdAt)}</div>
            </div>
          </Col>
        </Row>
      </Card>

      <div className="profiles-section">
        <Tabs
          activeKey={activeProfileTab}
          onChange={(key) => {
            setActiveProfileTab(key);
            if (key === "matched" && matchedTalents.length === 0 && !matchedLoading) {
              fetchMatchedProfiles();
            }
          }}
          items={[
            {
              key: "submitted",
              label: `Profiles Submitted (${profiles.length})`,
              children: (
                <Card className="profiles-table-card">
                  <Table
                    columns={columns}
                    dataSource={profiles}
                    rowKey="id"
                    pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} rows` }}
                    scroll={{ x: 1400 }}
                  />
                </Card>
              ),
            },
            {
              key: "matched",
              label: `Matched Profiles`,
              children: (
                <Card
                  className="profiles-table-card"
                  extra={
                    <Button
                      size="small"
                      onClick={fetchMatchedProfiles}
                      loading={matchedLoading}
                    >
                      Refresh
                    </Button>
                  }
                >
                  {matchedLoading ? (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <Spin size="large" />
                    </div>
                  ) : matchedTalents.length === 0 ? (
                    <Empty description="No matched profiles found based on job skills." />
                  ) : (
                    <Table
                      dataSource={matchedTalents}
                      rowKey="id"
                      pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} rows` }}
                      scroll={{ x: 1100 }}
                      columns={[
                        {
                          title: "Name",
                          dataIndex: "name",
                          key: "name",
                          width: 150,
                          render: (name, record) => (
                            <a
                              href="#"
                              style={{ color: "#1890ff", fontWeight: 500 }}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/customer/talent-details/${record.id}`);
                              }}
                            >
                              {name}
                            </a>
                          ),
                        },
                        {
                          title: "Role",
                          dataIndex: "role",
                          key: "role",
                          width: 150,
                        },
                        {
                          title: "Primary Skills",
                          dataIndex: "primarySkills",
                          key: "primarySkills",
                          width: 250,
                          render: (skills) => (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                              {(skills || []).map((skill, i) => (
                                <Tag key={i} color="blue" style={{ marginBottom: 4 }}>{skill}</Tag>
                              ))}
                            </div>
                          ),
                        },
                        {
                          title: "Experience",
                          dataIndex: "experience",
                          key: "experience",
                          width: 120,
                        },
                        {
                          title: "Monthly Rate",
                          dataIndex: "monthlyRate",
                          key: "monthlyRate",
                          width: 130,
                          render: (rate) => (
                            <span style={{ fontWeight: 500 }}>₹ {Number(rate).toLocaleString("en-IN")}</span>
                          ),
                        },
                        {
                          title: "Partner",
                          dataIndex: "partnerOrganization",
                          key: "partnerOrganization",
                          width: 150,
                        },
                        {
                          title: "Action",
                          key: "action",
                          width: 160,
                          render: (_, record) => {
                            const reqStatus = requestStatusMap[record.id];
                            if (reqStatus) {
                              const statusConfig = {
                                pending: { color: "gold", icon: <ClockCircleOutlined />, text: "Pending" },
                                accepted: { color: "green", icon: <CheckOutlined />, text: "Accepted" },
                                rejected: { color: "red", icon: <CloseOutlined />, text: "Rejected" },
                              };
                              const cfg = statusConfig[reqStatus.status] || { color: "default", text: reqStatus.status };
                              return (
                                <Tag color={cfg.color} icon={cfg.icon}>
                                  {cfg.text}
                                </Tag>
                              );
                            }
                            return (
                              <Button
                                type="primary"
                                size="small"
                                icon={<UserAddOutlined />}
                                loading={requestingTalentId === record.id}
                                onClick={() => handleRequestInterview(record)}
                                style={{ background: "#00d9a9", borderColor: "#00d9a9" }}
                              >
                                Request Interview
                              </Button>
                            );
                          },
                        },
                      ]}
                    />
                  )}
                </Card>
              ),
            },
          ]}
        />
      </div>

      <Modal
        title="Cancel Interview"
        open={cancelModalVisible}
        onOk={handleSubmitCancelInterview}
        onCancel={() => {
          setCancelModalVisible(false);
          setSelectedProfile(null);
          setCancelReason("");
        }}
        okText="Cancel Interview"
        okButtonProps={{ danger: true }}
        cancelText="Go Back"
      >
        {selectedProfile && (
          <div>
            <div
              style={{
                marginBottom: 16,
                padding: 12,
                background: "#f8f9fd",
                borderRadius: 6,
              }}
            >
              <p style={{ margin: 0, fontWeight: 500 }}>{selectedProfile.name}</p>
              <p style={{ margin: "4px 0 0", color: "#666", fontSize: 13 }}>
                {selectedProfile.role}
              </p>
            </div>
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: 8,
                  color: "#014c75",
                  fontWeight: 500,
                }}
              >
                Reason for Cancellation *
              </label>
              <Input.TextArea
                rows={4}
                placeholder="Please provide a reason for cancelling the interview..."
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
              />
            </div>
          </div>
        )}
      </Modal>
    </JobDetailsWrapper>
  );
};

export default JobDetails;
